import type { IDataViewHeaderConfig, IUseDataViewOptions } from '@/domains/investor/components/DataView/DataView.types'
import { computed } from 'vue'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'
import { useReports } from '@/domains/investor/reports/composables/useReports.composable'
import { useReportsDataViewFilters } from '@/domains/investor/reports/composables/useReportsDataViewFilters'
import { ITEMS_PER_PAGE, REPORTS_CATEGORIES_SCOPE } from '@/domains/investor/reports/const/reports-view.const'
import { REPORTS_HEADER_CONFIG, REPORTS_FILTERS_LABELS } from '../const/reportsLabels.const'

export const useReportsDataView = async (options: IUseDataViewOptions = {}) => {
  const { useState } = useDataView()

  const {
    secondCategory,
    search,
    searchDraft,
    year,
    months,
    page,
    filters,
    clearFilters,
    onSearch,
    filterOptions,
    hasActiveFilters,
  } = useState({
    defaultCategoryScope: REPORTS_CATEGORIES_SCOPE,
    options,
    useFilters: useReportsDataViewFilters,
  })

  const { reports, reportsColumns, total, isLoading } = await useReports(
    filters,
    page,
    ITEMS_PER_PAGE,
    'investor-reports',
  )

  const headerConfig = computed<IDataViewHeaderConfig>(() => REPORTS_HEADER_CONFIG)

  return {
    secondCategory,
    search,
    searchDraft,
    year,
    months,
    page,
    itemsPerPage: ITEMS_PER_PAGE,
    filters,
    clearFilters,
    onSearch,
    filterOptions,
    reports,
    reportsColumns,
    total,
    isLoading,
    hasActiveFilters,
    filterLabels: REPORTS_FILTERS_LABELS,
    headerConfig,
  }
}
